export default "__VITE_ASSET__z2HajSoi__"